var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchieveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H19C18.47 16.11 15.72 19.78 12 20.92V12ZM12 12H5V6.3L12 3.19M12 1L3 5V11C3 16.55 6.84 21.73 12 23C17.16 21.73 21 16.55 21 11V5L12 1Z",
    fill: "#548170"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchieveIcon);
export default __webpack_public_path__ + "static/media/archieve_icon.69affeb448ce6c4c557145a5cc5310c5.svg";
export { ForwardRef as ReactComponent };